module.exports = __webpack_public_path__ + "img/testimonial1.50c37d78.jpeg";